import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import {
  dateRangeValidation,
  pastDateWithTodayValidation,
} from "@validations/utils";

export const DISCIPLINE = FORM_FIELDS.EMPLOYEE.DISCIPLINE;

export const disciplineValidation = yup.object().shape({
  [DISCIPLINE.REASON_FOR_PUNISHMENT]: yup
    .string()
    .required("Reason for punishment is required"),
  [DISCIPLINE.PUNISHMENT_DETAILS]: yup
    .string()
    .required("Punishment Details is required"),
  [DISCIPLINE.DATE]: yup
    .string()
    .test("validator-date", pastDateWithTodayValidation)
    .required("Date is required"),
  [DISCIPLINE.REMARKS]: yup.string().required("Remarks is required"),

  [DISCIPLINE.IS_SUSPEND]: yup.boolean(),
  [DISCIPLINE.SUSPEND_START_DATE]: yup.string().when(DISCIPLINE.IS_SUSPEND, {
    is: true,
    then: (schema) => schema.required("Suspend start date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  [DISCIPLINE.SUSPEND_END_DATE]: yup
    .string()
    .when(DISCIPLINE.IS_SUSPEND, {
      is: true,
      then: (schema) => schema.required("Suspend end date is required"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test({
      name: `is-${DISCIPLINE.SUSPEND_END_DATE}`,
      skipAbsent: true,
      test(value, schema) {
        return dateRangeValidation(
          DISCIPLINE.SUSPEND_START_DATE,
          DISCIPLINE.SUSPEND_END_DATE,
          schema,
        );
      },
    }),
});

export const disciplineUpdateValidation = yup.object().shape({
  [DISCIPLINE.SUSPEND_FINISH_DATE]: yup
    .string()
    .required("Suspend cancel date is required"),
});

export type DisciplineFormDataType = yup.InferType<typeof disciplineValidation>;
export type DisciplineUpdateFormDataType = yup.InferType<
  typeof disciplineUpdateValidation
>;
